var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 474,
    height: 420,
    viewBox: "0 0 474 420",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "20943798 [\xD0\x9F\xD0\xB5\xD1\x80\xD0\xB5\xD1\x82\xD0\xB2\xD0\xBE\xD1\x80\xD0\xB5\xD0\xBD\xD0\xB8\xD0\xB8\xCC\x86]"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.6916 291.263C60.1572 294.58 44.209 295.788 31.5755 280.468C13.428 258.443 7.83378 216.074 18.6249 180.217C21.238 171.572 24.8277 163.365 28.4138 155.167C33.0967 144.46 37.7736 133.767 40.2624 122.131C44.1974 103.676 41.4225 86.6841 38.6742 69.8561C38.4725 68.6211 38.271 67.3871 38.0722 66.1533C32.1681 29.5652 48.7238 13.654 75.084 3.82736C98.061 -4.74643 122.565 2.49658 142.705 11.663C152.832 16.2592 162.744 21.6372 172.625 26.9989C173.665 27.5629 174.704 28.1268 175.743 28.6896C197.289 40.3287 257.054 54.4204 281.758 51.3788C288.486 50.5422 295.244 49.1595 301.989 47.7793C318.91 44.317 335.751 40.8711 351.842 46.1059C368.256 51.4301 379.335 69.2628 383.147 92.1138C388.098 122 402.441 125.684 420.362 130.288C423.212 131.02 426.153 131.776 429.161 132.664C454.8 139.989 474.868 157.381 473.273 184.968C471.613 213.66 460.635 231.806 443.572 240.664C438.424 243.303 432.872 245.192 427.14 246.263C422.491 247.139 417.848 246.97 413.2 246.801C406.856 246.57 400.502 246.339 394.108 248.765C378.586 254.673 378.233 271.326 377.862 288.764C377.817 290.889 377.772 293.024 377.699 295.154C377.054 313.935 361.387 338.102 349.974 347.661C303.841 386.242 258.085 349.213 222.972 320.798C222.146 320.129 221.325 319.466 220.511 318.808C206.788 307.73 156.281 284.642 113.104 310.667C104.958 317.122 96.8609 323.886 88.8366 330.973C85.2862 334.107 73.3741 345.115 71.4591 346.947C65.2905 352.849 59.1858 358.947 53.1387 365.262L69.0822 373.775C73.4918 376.128 73.5098 382.441 69.1155 384.821L9.07302 417.341C7.79891 418.032 6.46048 418.221 5.2121 418.024C2.00558 417.516 -0.585828 414.45 0.115496 410.784L13.1072 342.847C13.2175 342.26 13.4119 341.723 13.6669 341.238C13.922 340.754 14.9582 339.648 15.2946 339.368C16.5066 338.488 18.0445 338.111 19.5313 338.346C19.8062 338.39 20.0779 338.454 20.3462 338.54C20.3462 338.54 20.8926 338.741 21.1562 338.872C21.7338 339.166 22.2765 339.57 22.7572 340.093L35.2776 353.678C35.2776 353.678 43.0521 339.344 57.4518 318.094C62.9265 310.016 69.3631 300.934 76.6916 291.263Z",
    fill: "#9CD5E7",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 84"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.186 269.242L190.348 329.99H292.945L279.571 269.242H199.186Z",
    fill: "#27467C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.834 74.7525V255.543C26.834 270.421 38.7343 282.582 53.6819 282.956C120.029 284.652 352.071 288.792 415.226 287.858C426.087 287.7 434.867 279.046 435.185 268.251C436.398 226.248 438.377 125.251 431.055 78.3605C429.509 68.4851 421.133 61.0965 411.11 60.7803C355.522 59.0122 109.544 53.3917 46.4175 54.8004C35.5281 55.0591 26.834 63.914 26.834 74.7525Z",
    fill: "#2F5497"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2432 73.8763V245.64C38.2432 254.322 45.2476 261.395 53.9706 261.524L406.142 265.851C414.793 265.98 421.884 259.051 421.913 250.441L422.505 80.2155C422.534 74.0631 417.594 69.0176 411.413 68.8595L50.8511 61.6146C43.9334 61.4565 38.2432 66.9908 38.2432 73.8763Z",
    fill: "#E2EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M424.556 272.893L38.2287 266.338C37.9543 266.338 37.7377 266.108 37.7521 265.849C37.7521 265.576 37.9832 265.375 38.2432 265.375L424.57 271.93C424.844 271.93 425.061 272.16 425.047 272.419C425.047 272.677 424.83 272.893 424.556 272.893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.699 276.415C230.699 278.887 232.721 280.9 235.205 280.9C237.689 280.9 239.711 278.887 239.711 276.415C239.711 273.942 237.689 271.93 235.205 271.93C232.721 271.93 230.699 273.942 230.699 276.415ZM231.681 276.415C231.681 274.474 233.255 272.893 235.205 272.893C237.155 272.893 238.743 274.474 238.743 276.415C238.743 278.355 237.14 279.936 235.205 279.936C233.27 279.936 231.681 278.355 231.681 276.415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.041 346.134H164.886C160.814 346.134 157.737 343.244 158.532 340.139L160.453 332.55C161.03 330.264 163.558 328.596 166.547 328.496L311.301 323.997C314.435 323.896 317.193 325.549 317.886 327.921L321.367 339.996C322.262 343.158 319.186 346.134 315.041 346.134Z",
    fill: "#2F5497"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M245.719 330.565C245.459 330.565 245.228 330.349 245.228 330.091C245.228 329.817 245.445 329.602 245.705 329.602L251.915 329.516C252.175 329.516 252.406 329.731 252.406 329.99C252.406 330.263 252.189 330.479 251.929 330.479L245.719 330.565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M164.092 341.95C164.063 341.95 164.034 341.95 164.02 341.95C163.76 341.907 163.572 341.662 163.616 341.389L164.497 335.869C164.973 332.908 167.501 330.723 170.519 330.68L236.317 329.717H236.332C236.592 329.717 236.823 329.932 236.823 330.191C236.823 330.464 236.606 330.68 236.346 330.68L170.548 331.643C168.006 331.686 165.869 333.512 165.479 336.013L164.598 341.533C164.525 341.777 164.323 341.95 164.092 341.95Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 233.746,
    y: 85.8789,
    width: 9.2574,
    height: 162.621,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 249.228,
    y: 85.8789,
    width: 9.2574,
    height: 162.621,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    x: 264.71,
    y: 85.8789,
    width: 9.2574,
    height: 162.621,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    x: 280.178,
    y: 85.8789,
    width: 9.2574,
    height: 162.621,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    x: 295.66,
    y: 85.8789,
    width: 9.2574,
    height: 162.621,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    x: 311.142,
    y: 85.8789,
    width: 9.2574,
    height: 162.621,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    x: 326.609,
    y: 85.8789,
    width: 9.2574,
    height: 162.621,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    x: 233.746,
    y: 163.387,
    width: 9.2574,
    height: 85.0984,
    fill: "#2F5497"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    x: 249.228,
    y: 192.641,
    width: 9.2574,
    height: 55.8602,
    fill: "#2F5497"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    x: 264.71,
    y: 120.35,
    width: 9.2574,
    height: 128.136,
    fill: "#2F5497"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    x: 280.178,
    y: 217.709,
    width: 9.2574,
    height: 30.7907,
    fill: "#2F5497"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    x: 295.66,
    y: 137.484,
    width: 9.2574,
    height: 111.016,
    fill: "#2F5497"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    x: 311.142,
    y: 156.703,
    width: 9.2574,
    height: 91.7826,
    fill: "#2F5497"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    x: 326.609,
    y: 177.604,
    width: 9.2574,
    height: 70.8961,
    fill: "#2F5497"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_12_-link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_12_",
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4771 100.843C58.4771 88.4808 68.5432 78.4473 80.9779 78.4473C93.4126 78.4473 103.479 88.4808 103.479 100.843C103.479 113.205 93.4126 123.239 80.9779 123.239C68.5577 123.239 58.4771 113.22 58.4771 100.843ZM68.1533 100.843C68.1533 107.901 73.9013 113.608 80.9779 113.608C88.069 113.608 93.8025 107.887 93.8025 100.843C93.8025 93.7851 88.0546 88.0784 80.9779 88.0784C73.8868 88.0784 68.1533 93.7995 68.1533 100.843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5874 101.343C58.8521 113.546 68.7817 123.344 80.9778 123.344C93.3544 123.344 103.374 113.263 103.374 100.843C103.374 88.5763 93.6094 78.6146 81.4777 78.3476V88.0279C88.29 88.2917 93.7424 93.9204 93.7424 100.843C93.7424 107.92 88.0356 113.667 80.9776 113.667C74.1004 113.667 68.4839 108.202 68.2224 101.343H58.5874ZM80.4777 88.0279C73.8174 88.2853 68.4772 93.6639 68.2224 100.343H58.5874C58.8484 88.3068 68.5113 78.6111 80.4777 78.3476V88.0279Z",
    fill: "#2F5497"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_15_-link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_15_",
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.342 100.843C113.342 88.4808 123.408 78.4473 135.843 78.4473C148.263 78.4473 158.344 88.4808 158.344 100.843C158.344 113.205 148.278 123.239 135.843 123.239C123.423 123.239 113.342 113.22 113.342 100.843ZM123.019 100.843C123.019 107.901 128.767 113.608 135.843 113.608C142.92 113.608 148.653 107.887 148.668 100.843C148.668 93.7851 142.92 88.0784 135.843 88.0784C128.752 88.0784 123.019 93.7995 123.019 100.843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape Copy",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.008 116.74C124.076 120.758 129.677 123.239 135.858 123.239C148.292 123.239 158.359 113.205 158.359 100.843C158.359 88.9782 149.086 79.2585 137.347 78.4955V88.1635C143.723 88.8974 148.682 94.2874 148.682 100.843C148.682 107.887 142.949 113.608 135.858 113.608C132.474 113.608 129.393 112.303 127.1 110.169L120.008 116.74ZM136.347 88.0875C136.185 88.0814 136.022 88.0784 135.858 88.0784C128.767 88.0784 123.033 93.7995 123.033 100.843C123.033 104.166 124.308 107.19 126.395 109.46L119.312 116.022C115.616 112.032 113.357 106.702 113.357 100.843C113.357 88.4808 123.423 78.4473 135.858 78.4473C136.021 78.4473 136.184 78.449 136.347 78.4524V88.0875Z",
    fill: "#2F5497"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_18_-link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_18_",
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.193 100.843C168.193 88.4808 178.26 78.4473 190.694 78.4473C203.114 78.4473 213.195 88.4808 213.195 100.843C213.195 113.205 203.129 123.239 190.694 123.239C178.274 123.239 168.193 113.22 168.193 100.843ZM177.87 100.843C177.87 107.901 183.618 113.608 190.694 113.608C197.771 113.608 203.519 107.887 203.519 100.843C203.519 93.7851 197.771 88.0784 190.694 88.0784C183.603 88.0784 177.87 93.7995 177.87 100.843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape Copy 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.994 118.171C210.028 114.063 213.238 107.824 213.238 100.843C213.238 88.9782 203.966 79.2585 192.227 78.4955V88.1635C198.603 88.8974 203.562 94.2874 203.562 100.843C203.562 104.585 201.944 107.953 199.364 110.289L204.994 118.171ZM191.227 88.0875C191.064 88.0814 190.901 88.0784 190.738 88.0784C183.647 88.0784 177.913 93.7995 177.913 100.843C177.913 107.901 183.661 113.608 190.738 113.608C193.7 113.608 196.426 112.609 198.595 110.933L204.205 118.787C200.451 121.583 195.79 123.239 190.738 123.239C178.317 123.239 168.237 113.22 168.237 100.843C168.237 88.4808 178.303 78.4473 190.738 78.4473C190.901 78.4473 191.064 78.449 191.227 78.4524V88.0875Z",
    fill: "#2F5497"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M207.967 249.391L63.618 248.313C60.7729 248.299 58.4766 245.984 58.4766 243.152V169.338C58.4766 166.492 60.8017 164.178 63.6613 164.178H208.01C210.87 164.178 213.195 166.492 213.195 169.338V244.231C213.195 247.106 210.855 249.42 207.967 249.391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.582 197.512L167.024 177.977L140.407 206.784L121.632 186.616L104.013 206.439L90.5094 190.109L63.8926 217.694V237.646C63.8926 240.277 66.03 242.418 68.6729 242.447L202.927 243.453C205.599 243.468 207.779 241.326 207.779 238.652V184.388L185.582 197.512Z",
    fill: "#E2EAFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    x: 185.697,
    y: 196.967,
    width: 0.491032,
    height: 46.4735,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    x: 166.778,
    y: 177.977,
    width: 0.491032,
    height: 65.1894,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    x: 140.161,
    y: 206.439,
    width: 0.491032,
    height: 36.5262,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    x: 121.877,
    y: 187.336,
    width: 0.491032,
    height: 55.6302,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    x: 103.767,
    y: 205.85,
    width: 0.491032,
    height: 37.1299,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    x: 90.5527,
    y: 188.715,
    width: 0.491032,
    height: 53.8908,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 90.7983,
    cy: 188.716,
    rx: 4.07268,
    ry: 4.05367,
    fill: "#3EC572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    opacity: 0.654564,
    d: "M106.699 205.849C106.699 207.33 105.5 208.523 104.012 208.523C102.525 208.523 101.326 207.33 101.326 205.849C101.326 204.369 102.525 203.176 104.012 203.176C105.5 203.176 106.699 204.369 106.699 205.849Z",
    fill: "#F7DF00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.809 187.336C124.809 188.816 123.611 190.01 122.123 190.01C120.636 190.01 119.437 188.816 119.437 187.336C119.437 185.855 120.636 184.662 122.123 184.662C123.611 184.662 124.809 185.855 124.809 187.336Z",
    fill: "#3EC572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.093 206.439C143.093 207.92 141.894 209.113 140.407 209.113C138.919 209.113 137.721 207.92 137.721 206.439C137.721 204.959 138.919 203.766 140.407 203.766C141.894 203.766 143.093 204.959 143.093 206.439Z",
    fill: "#3EC572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    opacity: 0.654564,
    d: "M169.71 177.978C169.71 179.459 168.511 180.652 167.024 180.652C165.536 180.652 164.337 179.459 164.337 177.978C164.337 176.498 165.536 175.305 167.024 175.305C168.511 175.305 169.71 176.498 169.71 177.978Z",
    fill: "#F7DF00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.629 196.967C188.629 198.447 187.43 199.64 185.943 199.64C184.455 199.64 183.256 198.447 183.256 196.967C183.256 195.486 184.455 194.293 185.943 194.293C187.43 194.293 188.629 195.486 188.629 196.967Z",
    fill: "#3EC572"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    d: "M100.186 151.889H60.6143C58.9535 151.889 57.6104 152.823 57.6104 153.973C57.6104 155.123 58.9535 156.057 60.6143 156.057H100.186C101.847 156.057 103.19 155.123 103.19 153.973C103.19 152.823 101.847 151.889 100.186 151.889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    d: "M100.186 142.688H60.6143C58.9535 142.688 57.6104 143.622 57.6104 144.772C57.6104 145.922 58.9535 146.856 60.6143 146.856H100.186C101.847 146.856 103.19 145.922 103.19 144.772C103.19 143.622 101.847 142.688 100.186 142.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    d: "M100.186 133.488H60.6143C58.9535 133.488 57.6104 134.423 57.6104 135.573C57.6104 136.723 58.9535 137.657 60.6143 137.657H100.186C101.847 137.657 103.19 136.723 103.19 135.573C103.19 134.423 101.847 133.488 100.186 133.488Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    d: "M155.196 151.889H115.624C113.963 151.889 112.62 152.823 112.62 153.973C112.62 155.123 113.963 156.057 115.624 156.057H155.196C156.856 156.057 158.199 155.123 158.199 153.973C158.185 152.823 156.842 151.889 155.196 151.889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    d: "M155.196 142.688H115.624C113.963 142.688 112.62 143.622 112.62 144.772C112.62 145.922 113.963 146.856 115.624 146.856H155.196C156.856 146.856 158.199 145.922 158.199 144.772C158.199 143.622 156.842 142.688 155.196 142.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    d: "M155.196 133.488H115.624C113.963 133.488 112.62 134.423 112.62 135.573C112.62 136.723 113.963 137.657 115.624 137.657H155.196C156.856 137.657 158.199 136.723 158.199 135.573C158.185 134.423 156.842 133.488 155.196 133.488Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    d: "M210.191 151.889H170.62C168.959 151.889 167.616 152.823 167.616 153.973C167.616 155.123 168.959 156.057 170.62 156.057H210.191C211.852 156.057 213.195 155.123 213.195 153.973C213.195 152.823 211.852 151.889 210.191 151.889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    d: "M210.191 142.688H170.62C168.959 142.688 167.616 143.622 167.616 144.772C167.616 145.922 168.959 146.856 170.62 146.856H210.191C211.852 146.856 213.195 145.922 213.195 144.772C213.195 143.622 211.852 142.688 210.191 142.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    d: "M210.191 133.488H170.62C168.959 133.488 167.616 134.423 167.616 135.573C167.616 136.723 168.959 137.657 170.62 137.657H210.191C211.852 137.657 213.195 136.723 213.195 135.573C213.195 134.423 211.852 133.488 210.191 133.488Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_2",
    opacity: 0.367796,
    cx: 377.619,
    cy: 160.54,
    rx: 18.3126,
    ry: 18.2271,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M388.494 156.687C389.058 158.053 389.375 159.562 389.375 161.129C389.375 167.598 384.104 172.83 377.619 172.83C371.12 172.83 365.864 167.583 365.864 161.129C365.864 154.66 371.135 149.428 377.619 149.428C377.822 149.428 378.009 149.428 378.212 149.442V146.481C378.009 146.467 377.822 146.467 377.619 146.467C369.474 146.467 362.874 153.036 362.874 161.143C362.874 169.251 369.474 175.82 377.619 175.82C385.765 175.82 392.365 169.251 392.365 161.143C392.365 159.145 391.96 157.248 391.238 155.508L388.494 156.687Z",
    fill: "#2F5497"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    opacity: 0.5,
    d: "M392.668 186.473H362.83C360.953 186.473 359.437 187.982 359.437 189.851C359.437 191.719 360.953 193.229 362.83 193.229H392.668C394.545 193.229 396.062 191.719 396.062 189.851C396.047 187.982 394.531 186.473 392.668 186.473Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_3",
    opacity: 0.367796,
    cx: 377.532,
    cy: 101.963,
    rx: 18.3126,
    ry: 18.2271,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M383.757 112.457C381.938 113.593 379.8 114.254 377.49 114.254C370.991 114.254 365.734 109.007 365.734 102.553C365.734 96.0842 371.005 90.8518 377.49 90.8518C377.692 90.8518 377.879 90.8518 378.082 90.8662V87.905C377.879 87.8906 377.692 87.8906 377.49 87.8906C369.344 87.8906 362.744 94.4599 362.744 102.567C362.744 110.675 369.344 117.244 377.49 117.244C380.335 117.244 382.978 116.439 385.231 115.059L383.757 112.457Z",
    fill: "#2F5497"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    opacity: 0.5,
    d: "M392.74 127.91H362.903C361.025 127.91 359.509 129.42 359.509 131.288C359.509 133.157 361.025 134.666 362.903 134.666H392.74C394.618 134.666 396.134 133.157 396.134 131.288C396.134 129.42 394.618 127.91 392.74 127.91Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval_4",
    opacity: 0.91,
    cx: 377.672,
    cy: 219.408,
    r: 18.2698,
    transform: "rotate(-45 377.672 219.408)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    d: "M387.656 225.99C385.533 229.081 381.981 231.107 377.937 231.107C371.438 231.107 366.181 225.861 366.181 219.406C366.181 212.938 371.452 207.705 377.937 207.705C378.139 207.705 378.327 207.705 378.529 207.72V204.759C378.327 204.744 378.139 204.744 377.937 204.744C369.791 204.744 363.191 211.313 363.191 219.421C363.191 227.528 369.791 234.097 377.937 234.097C382.977 234.097 387.411 231.582 390.083 227.744L387.656 225.99Z",
    fill: "url(#paint0_linear_2242_101616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    opacity: 0.5,
    d: "M362.758 251.504H392.596C394.473 251.504 395.989 249.995 395.989 248.126C395.989 246.257 394.473 244.748 392.596 244.748H362.758C360.881 244.748 359.364 246.257 359.364 248.126C359.364 249.995 360.881 251.504 362.758 251.504Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M383.988 350.82C383.988 350.82 384.782 355.276 385.172 359.675C385.317 361.4 383.988 362.895 382.255 362.967C376.363 363.211 363.74 363.686 359.22 363.484C358.541 363.456 358.093 362.766 358.353 362.133C358.57 361.601 358.974 361.184 359.494 360.94L380.334 351.41L383.988 350.82Z",
    fill: "#3C2DA1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M384.638 348.203L384.002 353.522C384.002 353.522 380.348 355.218 377.864 353.306L379.381 347.369L384.638 348.203Z",
    fill: "url(#paint1_linear_2242_101616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M384.161 248.084C384.435 249.478 385.634 317.485 378.326 347.96C378.211 348.463 378.456 348.966 378.933 349.167C380.059 349.627 382.254 350.288 384.883 350.375C385.692 350.403 386.428 349.871 386.659 349.095C388.753 342.023 398.747 306.589 400.062 272.751C401.52 234.931 400.062 271.457 400.062 271.457L399.209 248.084H384.161Z",
    fill: "url(#paint2_linear_2242_101616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.961 353.148C407.961 353.148 409.218 355.391 410.431 361.371C410.647 362.449 409.896 363.484 408.799 363.584C406.849 363.771 403.86 364.016 401.448 364.001C400.336 363.987 399.484 363.038 399.614 361.946C399.874 359.761 400.711 356.196 403.268 353.407L407.961 353.148Z",
    fill: "#3C2DA1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M409.074 346.291L407.586 354.341C407.586 354.341 406.113 355.433 403.225 354.643L403.932 345.975L409.074 346.291Z",
    fill: "url(#paint3_linear_2242_101616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M413.074 250.167C419.053 286.047 411.775 338.859 409.334 349.195C409.189 349.827 408.67 350.316 408.02 350.417C406.922 350.603 405.117 350.747 403.34 350.23C402.734 350.057 402.301 349.497 402.272 348.864C401.94 340.512 402.532 289.209 396.971 268.941C396.683 267.92 396.062 267.014 395.181 266.396L384.378 258.749L383.555 246.387L413.074 250.167Z",
    fill: "url(#paint4_linear_2242_101616)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.005 182.176C392.913 181.888 412.656 186.848 412.656 186.848C417.985 217.84 413.594 253.59 413.594 253.59C399.73 257.212 384.103 251.376 384.103 251.376C381.793 238.424 371.048 201.97 371.048 201.97C362.296 200.892 355.089 198.376 349.168 195.056C353.688 189.838 355.826 183.182 356.75 179.258C363.076 181.213 369.488 182.262 375.005 182.176Z",
    fill: "url(#paint5_linear_2242_101616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.132 155.928C323.894 153.815 326.118 154.821 326.118 154.821C328.746 165.904 342.567 174.874 356.764 179.273C355.84 183.197 353.702 189.853 349.182 195.071C325.612 181.875 322.132 155.928 322.132 155.928Z",
    fill: "url(#paint6_linear_2242_101616)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.551 156.459C322.363 157.049 324.829 157.792 326.086 155.42C326.129 154.284 326.493 149.516 325.815 148.596C322.161 143.651 315.084 137.441 315.084 137.441C313.885 138.62 314.867 139.77 314.867 139.77L318.305 143.335C317.583 144.629 316.716 145.721 316.297 147.274C315.98 148.452 316.182 149.717 316.774 150.796C317.38 151.874 318.204 153.282 318.969 154.375C320.457 156.445 322.551 156.459 322.551 156.459Z",
    fill: "#BF9E6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.807 145.621L322.941 148.266L323.923 150.897L321.136 153.973C321.136 153.973 320.197 148.755 319.504 147.634C318.796 146.498 319.157 145.952 319.807 145.621Z",
    fill: "url(#paint7_linear_2242_101616)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M405.795 204.097L412.655 186.848C412.655 186.848 429.379 198.161 432.123 212.492C428.96 212.722 423.212 213.542 417.58 216.373C416.367 209.603 405.795 204.097 405.795 204.097Z",
    fill: "#95CAFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M391.18 220.341C391.18 220.341 409.955 230.906 416.295 221.879C417.609 220.01 417.927 218.141 417.595 216.373C423.227 213.542 428.975 212.722 432.138 212.492C432.961 216.819 432.528 221.419 429.972 226.062C418.88 246.258 388.696 224.941 388.696 224.941L391.18 220.341Z",
    fill: "url(#paint8_linear_2242_101616)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.447 233.695L383.208 198.075C383.092 197.672 382.745 197.37 382.327 197.327C380.464 197.112 375.091 196.508 368.881 195.99C361.4 195.358 352.706 194.855 347.521 195.286C346.785 195.344 346.337 196.12 346.669 196.781C349.615 202.732 361.761 226.91 367.841 234.831C368.043 235.09 368.361 235.248 368.693 235.248L392.465 235.032C393.129 235.018 393.635 234.357 393.447 233.695Z",
    fill: "#2F5497"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.798 192.899L360.375 191.663C359.985 191.591 359.653 191.979 359.783 192.353L360.519 194.567C360.577 194.754 360.75 194.897 360.952 194.926L368.101 195.875C368.477 195.918 368.78 195.587 368.693 195.228L368.231 193.287C368.188 193.1 368.015 192.942 367.798 192.899Z",
    fill: "#EDF2FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M373.358 199.167L372.752 195.99C372.694 195.674 372.42 195.43 372.102 195.401L357.096 193.892C356.591 193.834 356.187 194.294 356.302 194.797L357.255 198.75C357.327 199.066 357.602 199.296 357.934 199.311L372.593 200.044C373.084 200.058 373.459 199.627 373.358 199.167Z",
    fill: "#EDF2FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.963 225.098C390.963 225.098 392.392 219.262 391.815 217.178C391.237 215.108 390.125 212.434 386.399 213.038C382.687 213.627 378.297 215.194 378.297 215.194C378.297 215.194 378.514 217.897 381.344 217.02L379.597 218.371C379.597 218.371 379.842 220.527 382.24 219.377L380.608 221.174C380.608 221.174 381.633 222.942 383.395 221.806C385.142 220.656 385.98 225.803 390.963 225.098Z",
    fill: "#BF9E6C"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.144 167.699L398.834 184.101C398.935 184.374 398.819 184.676 398.559 184.805C397 185.653 391.411 188.126 384.666 183.871C383.959 183.425 383.482 182.706 383.381 181.887L381.532 167.699H393.144Z",
    fill: "url(#paint9_linear_2242_101616)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M380.391 150.765C380.217 150.995 374.859 169.568 374.859 169.568L385.575 172.385L393.273 155.538C393.288 155.538 383.265 146.798 380.391 150.765Z",
    fill: "#BF9E6C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    d: "M389.027 156.789C389.287 157.206 389.345 157.724 389.172 158.184L385.865 167.24C385.821 167.383 385.749 167.498 385.662 167.628C385.186 168.275 383.496 170.23 381.546 168.39C379.885 166.823 378.326 165.414 376.882 164.983C376.029 164.738 375.148 165.227 374.903 166.075C374.412 167.815 373.473 171.365 373.098 174.614C372.997 175.433 373.56 176.181 374.369 176.339C376.506 176.756 380.709 177.446 384.29 177.259C384.882 177.23 385.402 176.871 385.648 176.353C386.745 174.024 389.851 167.498 391.02 165.788C392.104 164.207 394.674 164.221 395.844 164.336C396.292 164.379 396.725 164.235 397.057 163.933C398.054 163.042 399.7 160.972 397.332 158.471C396.739 157.853 396.783 156.861 397.404 156.257C398.501 155.194 399.57 153.368 397.779 151.111C395.96 148.826 393.562 149.056 392.002 149.559C391.309 149.789 390.515 149.544 390.11 148.941C389.937 148.667 389.648 148.466 389.186 148.466C388.305 148.452 387.612 147.805 387.612 146.928C387.612 145.433 387.034 143.608 384.493 142.788C379.813 141.293 376.838 145.778 376.52 149.142C376.203 152.505 381.359 153.842 384.406 153.641C386.644 153.497 388.305 155.639 389.027 156.789Z",
    fill: "url(#paint10_linear_2242_101616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M389.764 169.124C389.764 169.124 390.572 163.288 393.028 163.014C395.468 162.756 397.837 164.768 395.367 168.031C392.305 172.085 389.764 169.124 389.764 169.124Z",
    fill: "#BF9E6C"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2242_101616",
    x1: 374.339,
    y1: 168.705,
    x2: 313.484,
    y2: 216.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2242_101616",
    x1: 377.864,
    y1: 347.369,
    x2: 377.864,
    y2: 354.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2242_101616",
    x1: 378.298,
    y1: 248.084,
    x2: 378.298,
    y2: 350.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57CBC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BF8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2242_101616",
    x1: 403.225,
    y1: 345.975,
    x2: 403.225,
    y2: 354.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2242_101616",
    x1: 383.555,
    y1: 246.387,
    x2: 383.555,
    y2: 350.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64E0D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BF8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2242_101616",
    x1: 354.06,
    y1: 200.985,
    x2: 394.364,
    y2: 220.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EAAE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95CAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2242_101616",
    x1: 366.114,
    y1: 180.427,
    x2: 338.401,
    y2: 162.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2242_101616",
    x1: 315.734,
    y1: 149.019,
    x2: 322.303,
    y2: 152.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2242_101616",
    x1: 413.243,
    y1: 210.409,
    x2: 412.475,
    y2: 223.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2242_101616",
    x1: 381.532,
    y1: 167.699,
    x2: 381.532,
    y2: 186.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F8A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9E6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2242_101616",
    x1: 399.231,
    y1: 154.377,
    x2: 375.255,
    y2: 145.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysis);
export default __webpack_public_path__ + "static/media/analysis.da1cda2a19577e5f898d00692eb9cf9e.svg";
export { ForwardRef as ReactComponent };